import React from 'react';
import Table from './Table';
class Result extends React.Component {

  render() {
    return (
      <Table />
    );
  }
}

export default Result;
